import type { RouteRecordRaw } from 'vue-router';
import { useRouter } from 'vue-router';
import { AuthRoutines } from '@platform/store';
import type { Ref } from 'vue';
import { inject, nextTick, onMounted, provide, shallowRef } from 'vue';
import { initMetrika } from '@platform/layouts/login/metrika-init';

export const LoadedRoutesSymbol = Symbol.for('$LoadedRoutes');

export function useLoginEnabledApp(routes: () => Promise<RouteRecordRaw[]>) {
    const loadedRoutesRef = shallowRef<RouteRecordRaw[] | null>();
    provide(LoadedRoutesSymbol, loadedRoutesRef);
    const router = useRouter();
    AuthRoutines.addRoutine('auth', async () => {
        if (window.location.pathname.startsWith('/public/') || window.location.pathname.startsWith('/sign-in/guest')) {
            return;
        }
        const loadedRoutes = await routes();
        router.hasRoute('SignedBaseLayout') && router.removeRoute('SignedBaseLayout');
        router.hasRoute('AuthRoutePages') && router.removeRoute('AuthRoutePages');
        router.options.routes = loadedRoutes;
        loadedRoutes.forEach((r) => router.addRoute(r));
        await router.replace(window.location.pathname + window.location.search);
        loadedRoutesRef.value = [...loadedRoutes];
    });
    AuthRoutines.addRoutine('logout', () => {
        setTimeout(() => router.replace({ name: 'LoginPage' }), 10);
    });
    onMounted(() => {
        nextTick(() => {
            const currentRoute = window.location.pathname;
            const r = router.resolve(currentRoute);
            if (r?.meta?.mobile) return; // Для мобильных роутов своя логика авторизации в mobile-loader.vue
            if (AuthRoutines.onLoad()) {
                AuthRoutines.fetchUserData().then(initMetrika);
            } else {
                console.log(r);
                if (r && !r?.meta?.public) {
                    router.push({ name: 'LoginPage' });
                }
                initMetrika(null);
            }
        });
    });
}

export function useInjectRoutes() {
    const loadedRoutes = inject<Ref<RouteRecordRaw[] | null>>(LoadedRoutesSymbol);
    return { loadedRoutes };
}
